module.exports = __webpack_public_path__ + "static/media/steviebg.1025e0f5.png";